<template>
  <div>
    <Organization :v="v" />

    <div class="form-section-base__controls">
      <v-radio-group v-model="v.trusteeType.$model" row>
        <v-radio
          label="Представитель заявителя по доверенности в бумажном виде"
          :value="TrusteeType.TRUSTEE"
        />
        <v-radio
          label="Лицо действующее от имени юридического лица без доверенности"
          :value="TrusteeType.ASSIGNEE"
        />
      </v-radio-group>
    </div>

    <OrganizationTrustee
      v-if="v.trusteeType.$model === TrusteeType.TRUSTEE"
      :v="v.trustee"
      :label="TrusteeLabel.ORGANIZATION"
    />
    <Assignee
      v-if="v.trusteeType.$model === TrusteeType.ASSIGNEE"
      :v="v.assignee"
      :label="TrusteeLabel.ORGANIZATION"
    />
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import OrganizationTrustee, {
  organizationTrusteeModel,
  getOrganizationTrusteeValidation,
  prefillEsiaOrgTrustee,
} from '@/components/services/EgrnConfirm/Applicant/components/OrganizationTrustee';
import {
  FieldLabel,
  FieldName,
  Mask,
  TrusteeLabel,
  TrusteeType,
} from '@/constants';
import Assignee, {
  getAssigneeValidation,
  assigneeModel,
  prefillEsiaAssignee,
} from '@/components/services/EgrnConfirm/Applicant/components/Assignee';
import Organization, {
  organizationModel,
  organizationValidation,
  prefillEsiaOrg,
} from '@/components/services/EgrnConfirm/Applicant/components/Organization';

export const mrpaDisableOrganizationModel = {
  ...cloneDeep(organizationModel),
  trusteeType: TrusteeType.TRUSTEE,
  trustee: cloneDeep(organizationTrusteeModel),
  assignee: cloneDeep(assigneeModel),
};

export const getMrpaDisableOrganizationValidation = (organization) => {
  const orgValidation = {
    ...organizationValidation,
    trusteeType: {},
  };

  if (organization.trusteeType === TrusteeType.TRUSTEE) {
    orgValidation.trustee = getOrganizationTrusteeValidation(
      organization.trustee
    );

    return orgValidation;
  }

  orgValidation.assignee = getAssigneeValidation(organization.assignee);
  return orgValidation;
};

export const prefillEsiaMrpaDisableOrganization = async () => {
  const esiaOrg = await prefillEsiaOrg();

  return cloneDeep({
    ...mrpaDisableOrganizationModel,
    ...esiaOrg,
    trustee: await prefillEsiaOrgTrustee(),
    assignee: await prefillEsiaAssignee(),
  });
};

export default {
  name: 'MrpaDisableOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    OrganizationTrustee,
    Assignee,
    Organization,
  },
  data: () => ({
    TrusteeType,
    TrusteeLabel,
    Mask,
    FieldName,
    FieldLabel,
  }),
};
</script>
